import { StandardProcessSteps } from '@constants/process-steps';

export const SINGLE_INVITE = 'single';
export const MULTIPLE_INVITE = 'multiple';
export const OPTION_SEND_LINK = 'send-link';
export const OPTION_FILL_INFO = 'fill-info';

export type ProcessInviteGuestStep = StandardProcessSteps;
export type InvitationType = typeof SINGLE_INVITE | typeof MULTIPLE_INVITE | '';
export type InvitationInfoType = typeof OPTION_SEND_LINK | typeof OPTION_FILL_INFO | '';
export interface InviteGuestForm {
  eventId: string;
  invitationId: string;
  quantity: number;
  type: InvitationType;
  infoType: InvitationInfoType;
  channelId: string;
  addOns?: string[];
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  gender?: string;
  nationality?: string;
  birth?: string;
  multiInviteText?: string;
}

// Type for the form data from useProcessForm
export interface ProcessFormFields {
  eventId: string;
  offerId: string;
  channelId: string;
  quantity: number;
  invitationId?: string;
  type?: string;
  infoType?: string;
  multiInviteText?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  gender?: string;
  nationality?: string;
  birth?: string;
}
